import { ProfileYourAwardsCardSkeleton } from './profile-your-awards-card-skeleton'
import React from 'react'
import { Row } from 'react-bootstrap'
import { Skeleton } from 'src/component/ui/skeleton'

export const ProfileNotCompletedChallengeCategorySkeleton = (): React.ReactElement => {
  return (
    <div className="mb-[30px]">
      <Skeleton className="h-7 w-48 mb-4 bg-tertiary-grey" />
      <Row>
        {Array.from({ length: 6 }).map((_, index) => (
          <ProfileYourAwardsCardSkeleton key={index} />
        ))}
      </Row>
    </div>
  )
}
